export const SA_ACTIONS = {
    GET_DOC_STUCK_ERROR: 'GET_DOC_STUCK_ERROR',
    GET_DOC_STUCK_LOADING: 'GET_DOC_STUCK_LOADING',
    GET_DOC_STUCK_SUCCESS: 'GET_DOC_STUCK_SUCCESS'
}